<template>
  <div>
    <v-container fluid>
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row style="margin-bottom: 1rem">
            <v-col cols="12" md="6">
              <h1 style="font-weight: 600; font-size: 28px;" class="mr-4">{{ $t('promptTemplateGroupList') }}</h1>
            </v-col>
            <v-col cols="6" class="d-flex flex-wrap justify-end" style="display: flex; align-items: center;">
              <div class="custom-search-input-wrapper-1 mr-3">
                <div class="custom-search-input-container">
                  <v-icon class="custom-search-input-icon">mdi-magnify</v-icon>
                  <input id="groupname-field-search-groupprompt" type="text" :placeholder="$t('promptTemplateGroupName')"
                    :aria-label="$t('promptTemplateGroupName')"
                    class="custom-search-input" v-model="searchName" @keydown.enter="Search" />
                  <v-icon class="clear-icon" :style="searchName ? '' : 'color: transparent !important;'"
                    @click="searchName = ''">
                    mdi-close-circle
                  </v-icon>
                </div>
              </div>
              <v-btn
                id="button-add-groupprompt"
                color="primary"
                class="control-btn create-btn customadd"
                variant="flat"
                size="large"
                prepend-icon="mdi-plus"
                rounded="xl"
                @click="Add()"
              >
                {{ $t('add') }}
                <v-tooltip activator="parent" location="top">{{ $t('_addNewPromptGroup') }}</v-tooltip>
              </v-btn>
            </v-col>
          </v-row>
          <v-data-table-server 
            :items-per-page="options.itemsPerPage" 
            :items-length="searchTotalTable"
            v-model:options="options" 
            :items="menus"
            :headers="headers"
            :loading="loadingTable"
            >
            <template v-slot:item="{ item }">
              <tr>
                <td style="text-align: center">{{ item.number }}</td>
                <td>{{ item.name }}</td>
                <td style="text-align: center">
                  <div class="action-group" style="justify-content: center;">
                    <!-- Edit -->
                    <v-btn
                      id="button-edit-groupprompt"
                      variant="text"
                      density="comfortable"
                      @click="Edit(item)"
                      class="action-btn edit-btn"
                      icon
                    >
                      <v-img :src="images.editBtn" width="23" height="23"></v-img>
                      <v-tooltip activator="parent" location="top">
                        {{ $t('edit') }}
                      </v-tooltip>
                    </v-btn>
                    <!-- Delete -->
                    <v-btn
                      id="button-delete-groupprompt"
                      variant="text"
                      density="comfortable"
                      @click="DeleteGroup(item.groupPromptTemplateID)"
                      class="action-btn delete-btn"
                      icon
                    >
                      <v-img :src="images.deleteBtn" width="23" height="23"></v-img>
                      <v-tooltip activator="parent" location="top">
                        {{ $t('delete') }}
                      </v-tooltip>
                    </v-btn>
                  </div>
                </td>
              </tr>
            </template>
             <!-- Custom footer -->
          <template v-slot:bottom>
            <div
              class="d-flex justify-space-between align-center px-4 py-2"
              style="width: 100%"
            >
              <div>{{ $t('totalResults') }} {{ searchTotalTable }}</div>

              <v-data-table-footer
                v-model:items-per-page="itemsPerPage"
                :page="options.page"
                :length="Math.ceil(searchTotalTable / itemsPerPage)"
              />
            </div>
          </template>

          <!-- No Data Slot -->
          <template v-slot:no-data>
            <div class="no-data-container">
              <div class="no-data-content">
                <h3 style="color: #646464!important;">{{ $t('noDataAvailable') }}</h3>
              </div>
            </div>
          </template>
          </v-data-table-server>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- Loading Please Wait... -->
    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">{{ $t('loading') }}</h3>
          <p class="loading-subtitle">{{ $t('pleaseWait') }}</p>
        </v-card-text>
      </v-card>
    </v-overlay>
    <!-- Custom Delete Dialog -->
    <v-dialog v-model="dialog_delete" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="delete-dialog-title">{{ $t('deletePromptTemplateGroup') }}</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="delete-close-icon"
            @click="cancelDelete"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span v-if="deleteItem">
            {{ $t('_confirmDeletePromptTemplateGroup') }}
          </span>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="delete-cancel-btn"
            @click="cancelDelete"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            class="delete-confirm-btn"
            @click="confirmDelete"
          >
            <v-img :src="images.deleteIcon" width="20" height="20" class="mr-2"/>
            {{ $t('delete') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import editBtn from '@/assets/images/editbutton.png';
import deleteBtn from '@/assets/images/trashbutton.png';
import deleteIcon from "@/assets/images/trash-solid.svg";
import groupCrudCommonMixin from "@/mixins/groupCrudCommonMixin.js";
  export default {
    name: 'GroupPromptTemplate',
    inject: ['flagNav','FontColorTitle','SubNavbarBackGround'],
    mixins: [groupCrudCommonMixin],
    data: () => ({
    checkbox1: false,
    Editdialog: false,
    Adddialog: false,
    Detaildialog: false,
    dialog: false,
    today: null,

    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    loading: true,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    DDGPTModel: [],
    headers_version_history: [],
    images: {
      deleteBtn: deleteBtn,
      editBtn: editBtn,
      deleteIcon: deleteIcon,
    },
    dialog_delete: false,
    deleteItem: null,
    searchName: '',
    isSearch: false,
    isFirst: true,
    menus: [],
    GroupModel: {
      GroupID: null,
      Name: null,
      Model: null,
      NameModel: null,
    },
    sortBy: [],
    sortDesc :[],
  }),
  computed: {
    headers() {
      return [
        { title: this.$t('no'), align: 'center', sortable: false, width: '95px' },
        { title: this.$t('promptTemplateGroupName'), align: 'left', sortable: true ,value:'Name', width: 'auto' },
        // { text: this.$t('totalNumber'), align: 'center', sortable: true ,value:'Count'},
        { title: this.$t('manage'), align: 'center', sortable: false, width: '220px' },
      ];
    },
  },
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
    },
  },
  methods: {
    Search() {
      this.dialog = true;
      this.isSearch = true;
      this.options.page = 1;
      this.GetDefault();
    },
    Get() {
      this.loadingTable = true;
      this.fetchServerTable(
        (temp, onSuccess, onError) => this.$call.GetTableGroupPromptTemplate(temp, onSuccess, onError),
        {
          onSuccess: () => {
            this.loadingTable = false;
            this.isSearch = false;
            this.isFirst = false;
          },
          onError: () => {
            this.loadingTable = false;
            this.isSearch = false;
          },
        }
      );
    },
    GetDefault() {
      this.dialog = true;
      this.loading = true;
      this.fetchServerTable(
        (temp, onSuccess, onError) => this.$call.GetTableGroupPromptTemplate(temp, onSuccess, onError),
        {
          withSort: false,
          query: { page: 1 },
          onSuccess: () => {
            this.dialog = false;
            this.isSearch = false;
            this.isFirst = false;
          },
          onError: () => {
            this.dialog = false;
            this.isSearch = false;
          },
        }
      );
    },
    confirmDelete() {
      if (!this.deleteItem) return;
      const id = this.deleteItem
      try {
            this.dialog = true;
            this.dialog_delete = false;
            this.$call.DeleteGroupPromptTemplate(
              id,
              (dataResponse) => {
                if (dataResponse.status == 0) {
                  this.dialog = false;
                  this.$swal.fire({
                    title: this.$t('_promptGroupDeletedSuccess'),
                    showConfirmButton: false,
                    timer: 1500,
                    position: 'top',
                    customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
                  });
                  this.Get();
                }
                this.dialog = false;
              },
              (errorResource) => {
                this.dialog = false;
                console.error(errorResource);
              }
            );
         }
        catch (error) {
        this.LogTrace(error, "DeleteTextGroup");
      }
    },
    Add() {
      this.$router.push({
        name: 'PromptTemplate',
        query: {
          id: null,
        },
      });
    },
    Edit(item) {
      this.$router.push({
        name: 'PromptTemplate',
        query: {
          id: item.groupPromptTemplateID,
          name: item.name,
        },
      });
    },
    substring(text) {
      if (text.length > 50) {
        return text.substring(0, 50) + '...';
      }
      return text;
    },
  },
  mounted() {
    this.GetDate();
  },
};
</script>
<style scoped>
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
:deep(thead) {
  background-color: #FFE4E1 !important;
  padding: 0 8px;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
}

.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0;
  padding: 0;
}

textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.action-divider {
  margin: 0 20px !important;
}

.no-data-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.custom-search-input-wrapper-1 {
  width: 100%;
  max-width: 300px;
}
</style>
